const customProperties = {
  apiKeys: {
    product: "Produkt",
    shape: "Form",
    material: "Material",
    finish: "Oberfläche / Finish",
    width: "Breite",
    height: "Höhe",
    quantity: "Menge",
    white_underprint: "WEIßER UNTERDRUCK",
  }
};

const uiTranslations = {
  // Buttons
  letsGo: "Los geht’s &gt;",
  settingDesigner: "Designer wird eingerichtet...",
  // Validation
  sizeValidation: "Maße müssen zwischen 3 cm und 29 cm liegen.",
};

const modalTranslations = {
  deleteTitle: "DESIGN LÖSCHEN?",
  deleteMsg: "Bist du sicher? Diese Aktion kann nicht rückgängig gemacht werden und das Design wird aus deinem Konto entfernt.",
  reorderTitle: "NACHBESTELLEN",
  reorderMsg: "Nochmal bestellen? Gleiche Einstellungen, gleiche Menge – Design anpassen geht noch im Warenkorb.",
  btnConfirmDelete: "LÖSCHEN",
  btnConfirmReorder: "IN DEN WARENKORB",
  btnCancel: "ABBRECHEN",

  // product options
  invalidCombinationTitle: "Ungültige Kombination",
  btnOk: "OK",
  holographicMatte: "Für holografisches Material ist keine matte Veredelung verfügbar.",
  vinylUnderprint: "Weißer Unterdruck ist für weißes Vinyl nicht verfügbar.",
  glitterMatte: "Für Glittermaterial ist keine matte Veredelung verfügbar.",

  // Cart-Specific Translations
  cartDeleteTitle: "AUS WARENKORB LÖSCHEN?",
  cartDeleteMsg: "Möchten Sie dieses Design wirklich aus dem Warenkorb entfernen?",
  volumeUpdateTitle: "MENGE AKTUALISIEREN?",
  volumeUpdateMsg: "Der Preis wird basierend auf der neuen Menge neu berechnet. Möchten Sie fortfahren?",
  btnConfirmUpdate: "Aktualisieren",
  editTitle: "DESIGN BEARBEITEN?",
  editMsg: "Du wirst zum Editor weitergeleitet, um dein Design zu ändern. Möchtest du fortfahren?",
  btnConfirmEdit: "JETZT BEARBEITEN"
};
const loadingMessages = {
  fetch: "Designs werden geladen...",
  remove: "Design wird gelöscht...",
  verify: "Design-Details werden verifiziert..."
};

const customerMessages = {
  email: {
    success: "E-Mail erfolgreich aktualisiert",
    sameAsCurrent: "Die neue E-Mail-Adresse ist identisch mit Ihrer aktuellen E-Mail-Adresse.",
    alreadyTaken: "Diese E-Mail-Adresse wird bereits verwendet. Bitte verwenden Sie eine andere.",
    error: "Bitte geben Sie eine gültige E-Mail ein."
  },
  info: {
    success: "Deine Kontodetails wurden erfolgreich aktualisiert.",
    error: "Fehler beim Aktualisieren der Kontodetails. Bitte versuche es erneut.",
    required: "Bitte füllen Sie alle erforderlichen Felder aus."
  },
  password: {
    resetSuccess: "Wir haben dir eine E-Mail zum Zurücksetzen deines Passworts gesendet.",
    tooManyRequests: "Zu viele Anfragen. Bitte versuchen Sie es später noch einmal."
  },
  validation: {
    invalidPhone: "Please enter a valid phone number."
  }
};

const registerTranslations = {
  errors: {
    firstNameShort: "Der Vorname muss mindestens zwei Buchstaben enthalten.",
    lastNameShort: "Der Nachname muss mindestens zwei Buchstaben enthalten.",
    invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    invalidPassword: "Das Passwort muss mindestens 8 Zeichen lang sein und Buchstaben, Zahlen sowie Sonderzeichen enthalten.",
    invalidVat: "Bitte gib eine gültige USt-IdNr. ein.",
    generalError: "Ungültige Kundendaten oder -details."
  }
};

const pricingTable = {
  vinyl: { m2: 8, setup: 25, unit: 0.01 },
  transparent: { m2: 8, setup: 25, unit: 0.01 },
  holographic: { m2: 10, setup: 30, unit: 0.012 }
};

async function waitForVariant(variantId, attempts = 40) {
  for (let i = 0; i < attempts; i++) {
    try {
      const response = await fetch(
        `/variants/${variantId}.js?t=${Date.now()}`,
        {
          method: 'GET',
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }
      );

      if (response.ok) {
        const variant = await response.json();

        if (Number(variant.id) === Number(variantId)) {
          console.log(`Variant ${variantId} is available`);

          // Small propagation buffer for Shopify cart infrastructure
          await sleep(1000);

          return variant;
        }
      }

    } catch (error) {
      console.warn(
        `Variant check ${i + 1}/${attempts} failed`,
        error
      );
    }

    await sleep(1000);
  }

  throw new Error('Variant not ready');
}

async function addToShopifyCart(data, attempts = 10) {

  const lineItemProperties = {
    Design_ID: data.design_id
  };

  if (data.properties) {
    Object.keys(data.properties).forEach(key => {

      if (!['price', 'product_code'].includes(key)) {

        const label = key
          .split('_')
          .map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
          )
          .join(' ');

        lineItemProperties[label] = data.properties[key];
      }
    });
  }


  for (let i = 0; i < attempts; i++) {

    const formData = new URLSearchParams();

    formData.append('id', String(data.variant_id));
    formData.append('quantity', '1');

    Object.entries(lineItemProperties).forEach(([key, value]) => {
      formData.append(
        `properties[${key}]`,
        value ?? ''
      );
    });


    try {

      console.log(
        `Adding variant ${data.variant_id}, attempt ${i + 1}/${attempts}`
      );

      const response = await fetch(
        `/cart/add.js?t=${Date.now()}`,
        {
          method: 'POST',
          cache: 'no-store',
          headers: {
            'Content-Type':
              'application/x-www-form-urlencoded;charset=UTF-8',
            'Cache-Control': 'no-cache'
          },
          body: formData.toString()
        }
      );


      const responseText = await response.text();

      console.log(
        'Cart add response:',
        response.status,
        responseText
      );


      if (response.ok) {

        try {
          return JSON.parse(responseText);

        } catch (error) {
          throw new Error(
            'Invalid JSON response from Shopify cart'
          );
        }
      }


      // New variant may not yet be available to cart infrastructure
      if (response.status === 422 && i < attempts - 1) {

        const delay = Math.min(
          1000 * Math.pow(1.5, i),
          5000
        );

        console.warn(
          `Variant not ready for cart. Waiting ${delay}ms`
        );

        await sleep(delay);

        continue;
      }


      throw new Error(
        `Cart Add Failed (${response.status}): ${responseText}`
      );


    } catch (error) {

      console.warn(
        `Cart add attempt ${i + 1} failed`,
        error
      );

      if (i === attempts - 1) {
        throw error;
      }

      await sleep(1000);
    }
  }

  throw new Error('Unable to add variant to cart');
}

function sleep(ms) {
  return new Promise(r => setTimeout(r, ms));
}

async function waitForCartItem(variantId, attempts = 30) {

  for (let i = 0; i < attempts; i++) {

    try {

      const response = await fetch(
        `/cart.js?t=${Date.now()}`,
        {
          method: 'GET',
          cache: 'no-store',
          headers: {
            'Cache-Control': 'no-cache'
          }
        }
      );


      if (!response.ok) {
        throw new Error(
          `Cart fetch failed: ${response.status}`
        );
      }


      const cart = await response.json();


      const foundItem = cart.items?.find(item =>
        Number(item.id) === Number(variantId) &&
        Number(item.quantity) > 0 &&
        Number(item.price) > 0
      );


      if (foundItem) {

        console.log(
          'Cart item confirmed:',
          {
            variantId: foundItem.id,
            quantity: foundItem.quantity,
            price: foundItem.price
          }
        );

        return foundItem;
      }


    } catch (error) {

      console.warn(
        `Cart verification ${i + 1}/${attempts} failed`,
        error
      );
    }


    await sleep(500);
  }


  throw new Error(
    'Updated cart item was not ready in time'
  );
}

function hideFullLoader() {

  const loader = document.getElementById('antigro-loader');
  if (loader) loader.style.display = 'none';

}

function showFullLoader(text) {

  let loader = document.getElementById('antigro-loader');

  if (!loader) {
    loader = document.createElement('div');
    loader.id = 'antigro-loader';
    loader.style = "position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.95);z-index:10000;display:flex;flex-direction:column;justify-content:center;align-items:center;";
    document.body.appendChild(loader);

    // Add the Lottie Library via CDN if not already present
    if (typeof lottie === 'undefined') {
      const script = document.createElement('script');
      script.src = "https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.9.6/lottie.min.js";
      document.head.appendChild(script);
    }
  }

  // Set the inner HTML with a container for the Lottie animation
  loader.innerHTML = `
    <div id="lottie-loader-container" style="width: 200px; height: 200px;"></div>
    <p style="margin-top:20px; font-family:sans-serif; font-weight:bold; color:#333;">${text}</p>
  `;
  loader.style.display = 'flex';

  // Initialize the Lottie animation
  // Wait a tiny bit to ensure the script is loaded and DOM is ready
  setTimeout(() => {
    lottie.loadAnimation({
      container: document.getElementById('lottie-loader-container'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      // Shopify Liquid will replace this with the actual CDN URL
      path: "//stickermate.com/cdn/shop/t/12/assets/loader.json?v=124191988802950024541777983642"
    });

    // Optional: Set speed to 2x if you want it faster as discussed
    lottie.setSpeed(1);
  }, 100);
}

/**
 * THE SINGLE SOURCE OF TRUTH FOR PRICING
 * Takes raw numbers, returns calculated price object.
 */
window.calculateStickerPrice = function (widthMm, heightMm, qty, matKey) {
  const p = pricingTable[matKey];
  if (!p) throw new Error(`No pricing configured for "${matKey}"`);

  const q = parseInt(qty, 10) || 1;
  const width = parseFloat(widthMm) || 0;
  const height = parseFloat(heightMm) || 0;
  const totalAreaM2 = ((width + 5) * (height + 5) / 1000000) * q;
  const total = (totalAreaM2 * p.m2) + p.setup + (q * p.unit);

  return {
    total,
    formatted: total.toFixed(2).replace('.', ',') + ' €',
    widthCm: (width / 10).toFixed(1).replace('.', ','),
    heightCm: (height / 10).toFixed(1).replace('.', ',')
  };
};

/**
 * Checks the cart for Design_IDs and claims them for the customer
 */
function syncGuestDesigns() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) throw new Error('Failed to fetch cart');
      return response.json();
    })
    .then(cart => {
      const designIds = [];

      // Loop through cart items to find Design IDs
      cart.items.forEach(item => {
        if (item.properties && item.properties.Design_ID) {
          designIds.push(item.properties.Design_ID);
        }
      });

      // Only call the backend if we actually found designs
      if (designIds.length > 0) {
        return fetch(`${backendUrl}/antigro/claim-designs`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            design_ids: designIds,
            email: customerGlobalEmail,
            customer_id: customerGlobalId
          })
        });
      }
    })
    .then(claimResponse => {
      if (claimResponse) {
        console.log("Designs successfully claimed/synced.");
      }
    })
    .catch(e => {
      console.error("Design sync error", e);
    });
}


/**popup modal for customer confirmation box */
const smModal = {
  element: document.getElementById('SmGlobalModal'),
  heading: document.getElementById('SmModalHeading'),
  message: document.getElementById('SmModalMessage'),
  confirmBtn: document.getElementById('SmModalConfirm'),
  cancelBtn: document.getElementById('SmModalCancel'),

  /**
   * Initializes global listeners like clicking outside to close
   */
  init: function () {
    if (!this.element) return;

    this.element.addEventListener('click', (e) => {
      // Check if the click was specifically on the overlay background
      const isOverlay = e.target.classList.contains('sm-modal-overlay') || e.target === this.element;
      if (isOverlay) {
        this.close();
      }
    });

    // Close on Escape key
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.element.classList.contains('is-open')) {
        this.close();
      }
    });
  },

  /**
   * @param {Object} config - { title, message, confirmText, cancelText, type, onConfirm }
   */
  open: function (config) {
    if (!this.element) return;

    this.heading.innerText = config.title || '';
    this.message.innerText = config.message || '';

    // Confirm button
    if (config.confirmText) {
      this.confirmBtn.innerText = config.confirmText;
      this.confirmBtn.style.display = '';
    } else {
      this.confirmBtn.style.display = 'none';
    }

    // Cancel button
    if (config.cancelText) {
      this.cancelBtn.innerText = config.cancelText;
      this.cancelBtn.style.display = '';
    } else {
      this.cancelBtn.style.display = 'none';
    }

    // Button style
    const btnClass = config.type === 'danger'
      ? 'sm-btn-danger'
      : 'sm-btn-primary';

    this.confirmBtn.className = `sm-btn ${btnClass}`;

    // Show modal
    this.element.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Handlers
    this.confirmBtn.onclick = () => {
      if (config.onConfirm) {
        config.onConfirm();
      }
      this.close();
    };

    this.cancelBtn.onclick = () => this.close();
  },

  close: function () {
    if (!this.element) return;
    this.element.classList.remove('is-open');
    document.body.style.overflow = ''; // Re-enable scroll
  }
};

// Initialize the modal listeners immediately
smModal.init();


function validateCombination(material, finish, underprint, combinations) {

  const rules = combinations[material];

  if (!rules) {
    return { valid: true };
  }

  if (rules.finish?.includes(finish)) {

    let messageKey = '';

    switch (material) {
      case 'holographic':
        messageKey = 'holographicMatte';
        break;

      case 'glitter':
        messageKey = 'glitterMatte';
        break;

      default:
        messageKey = 'invalidCombination';
    }

    return {
      valid: false,
      messageKey
    };
  }

  if (rules.white_underprint?.includes(underprint)) {
    return {
      valid: false,
      messageKey: 'vinylUnderprint'
    };
  }

  return { valid: true };
}


document.addEventListener('DOMContentLoaded', () => {
    if (!window.location.pathname.startsWith('/account/subscribe')) {
        return;
    }

    const container = document.querySelector('.shopify-email-marketing-confirmation__container');

    console.log(container);
    if (!container) return;

    const unsubscribeLink = container.querySelector('a')?.href || '#';
    console.log(unsubscribeLink);

    container.innerHTML = `
        <h1>Willkommen bei Stickermate</h1>

        <p>
            Stick with us! Du bist jetzt dabei – als Erstes erfährst du von neuen Drops,
            exklusiven Angeboten und Updates direkt in deinem Postfach.
        </p>

        <p>
            Dein Willkommensgeschenk:
            <strong>10 % Rabatt auf deine Bestellung.</strong>
        </p>

        <p>
            Einfach den Code <strong>WillkommenMate10</strong> an der Kasse eingeben.
        </p>

        <p>
            Du kannst dich jederzeit wieder abmelden.
        </p>

        <a href="${unsubscribeLink}">Abmelden</a>
    `;
});

document.addEventListener('DOMContentLoaded', () => {
    if (!window.location.pathname.startsWith('/account/unsubscribe')) {
        return;
    }

    const container = document.querySelector(
        '.shopify-email-marketing-confirmation__container'
    );

    if (!container) return;

    const form = container.querySelector(
        'form[action="/services/account/unsubscribe"]'
    );

    // After successful unsubscription, Shopify removes the form.
    if (!form) {
        container.innerHTML = `
            <h1>STICKERMATE</h1>
            <p>Du hast den Newsletter abbestellt.</p>
            <p>Du kannst dich jederzeit wieder anmelden.</p>
        `;
        return;
    }

    // Translate the initial unsubscribe page.
    const paragraphs = container.querySelectorAll('p');

    if (paragraphs[0]) {
        paragraphs[0].textContent = 'Newsletter abbestellen?';
    }

    if (paragraphs[1]) {
        paragraphs[1].textContent =
            'Wir werden dir keine Mails mehr mit News und exklusiven Angeboten senden.';
    }

    const button = form.querySelector('button[type="submit"]');

    if (button) {
        button.textContent = 'ABMELDEN';
    }
});